/**
 *
 * JobsPage (CP'd from VoiceModelsPage for redux stuff)
 *
 */
// @ts-nocheck
import * as React from 'react';
import {useEffect, useState} from 'react';
import styled from 'styled-components';
import {Helmet} from 'react-helmet-async';
import '../InferPage/Infer.css';
import {useNavigate, useOutletContext} from "react-router-dom";
import {motion} from "framer-motion";

import {Api} from "../../../store/api";
import Container from "@mui/material/Container";
import {PricingTable} from "app/pages/UpgradePage/pricingTable";
import { useFeatureFlagVariantKey } from 'posthog-js/react'
import { FaqsAccordion } from 'app/components/FaqsAccordion';
import { pricingFaqsData } from 'app/pages/FaqsPage/pricingFaqsData';
import { VoiceCreditCard } from 'app/components/VoiceCreditCard/Loadable';


interface Props {}

export function UpgradePage(props: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [userProfile] = useOutletContext();

  const posthogPricingTitleVariant = useFeatureFlagVariantKey('pricing-title-change');
  const posthogPricingSubtitleVariant = useFeatureFlagVariantKey('pricing-subtitle-change');


    useEffect(() => {
        return () => {
            // Track tiktok event
            // @ts-ignore
            window.ttq.track('ViewContent', {
                content_type: 'product_group',
                content_id: 'upgrade',
            })


        };
    }, []);

  const isCreator = userProfile?.plan?.includes('creator')
  const isStarter = userProfile?.plan?.includes('starter')
    // Creators should not see this page
    if (isCreator) {
        navigate('/app/voice-models')
    }

  return (
    <>
      <Helmet>
        <title>ControllaVoice Upgrade</title>
        <meta
          name="Controlla Voice"
          content="Generate and transform vocals using AI"
        />
      </Helmet>
      <div style={{overflowY: 'auto', height: 'calc(100dvh - 90px)'}}>
        {!isLoading && (
          <MotionContent
              initial={{translateY: '100px', opacity: 0}}
              animate={{translateY: "0px", opacity: 1}}
              exit={{translateY: "0px", opacity: 0}}
              transition={{duration: 0.5}}
          >
              <VoiceModelPageTitleAction>
                  <h2>{posthogPricingTitleVariant === 'new-title' ? 'Claim Your Creative Power' : 'Unleash your voice today!'}</h2>
                  <h3 style={{ marginBottom: '0px', fontSize: '18px' }}>
                    {posthogPricingSubtitleVariant === 'new-subtitle'
                      ? 'Unlock powerful tools today—get first access to the next wave of music innovation. From studio-grade voice swap to AI song generation and stem split, everything you need to craft your best sound is just beginning'
                      : 'Flexible plans to fit your needs, cancel anytime.'}
                  </h3>
              </VoiceModelPageTitleAction>
              <Container sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                  <PricingTable creator={isCreator} starter={isStarter} isCheckboxSelectMode={false} hideFreePlan={true} hideContractCard={false} small={false} />
              </Container>

            {/* Voice Credit Section - Only visible for Starter users */}
            {isStarter && (
              <VoiceCreditSection>
                <VoiceCreditTitle>
                  <h2>Add More Voices to Your Subscription</h2>
                </VoiceCreditTitle>
                <VoiceCreditContainer>
                  <VoiceCreditCard
                    title="1 Voice Credit"
                    description="to train 1 new voice model"
                    price={15}
                    priceHelper="one-time"
                    buttonText="BUY NOW"
                    onButtonClick={() => Api.redirectToAddOn('voice-credits-1')}
                  />
                  <VoiceCreditCard
                    title="5 Voice Credits"
                    description="to train 5 new voice models"
                    price={50}
                    priceHelper="one-time"
                    buttonText="BUY NOW"
                    onButtonClick={() => Api.redirectToAddOn('voice-credits-5')}
                  />
                </VoiceCreditContainer>
              </VoiceCreditSection>
            )}

              <h2>FAQs</h2>
              <FaqsAccordion faqs={pricingFaqsData} />
              <br />
          </MotionContent>
        )}
      </div>
    </>
  );
}

const Content = styled.div `
  max-width: 1200px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
`;

const MotionContent = motion(Content);

const VoiceModelPageTitleAction = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 20px;
`;

const VoiceCreditSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 28px 0 80px 0;

  @media (max-width: 768px) {
    margin: 20px auto 60px auto;
    width:90%;
  }
`;

const VoiceCreditTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;

  h2 {
    color: white;
    font-family: 'Raleway', sans-serif;
    font-size: 28px;
    font-weight: 700;
    text-align: center;
    margin: 0;
  }

  @media (max-width: 768px) {
    margin-bottom: 24px;

    h2 {
      font-size: 24px;
      line-height: 1.3;
    }
  }

  @media (max-width: 480px) {
    margin-bottom: 20px;

    h2 {
      font-size: 20px;
      line-height: 1.2;
    }
  }
`;

const VoiceCreditContainer = styled.div`
  width: 100%;
  max-width: 800px;
  display: flex;
  margin: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 20px;

  @media (max-width: 812px) {
    flex-direction: column;
    gap: 16px;
    margin: 0 16px;
  }

  @media (max-width: 480px) {
    gap: 12px;
    margin: 0 12px;
  }
`;
